import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "rt-portal-rt_list_select",
  "use": "rt-portal-rt_list_select-usage",
  "viewBox": "32 -232 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"32 -232 1024 1024\" id=\"rt-portal-rt_list_select\">\r\n<path d=\"M948.3,23.6c-15.6-15.5-41-15.5-56.6,0.1l-414,412.6c-3.1,3.1-8.2,3.1-11.3,0L196.3,167.1c-15.6-15.5-40.9-15.5-56.6,0\r\n\tc-15.6,15.5-15.6,40.8,0,56.4l321,319.8c6.2,6.2,16.4,6.2,22.6,0L948.3,80C963.9,64.5,963.9,39.2,948.3,23.6z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-sprite-loader/lib/loader.js?{"symbolId":"rt-portal-[name]"}!./src/assets/icons/svgs/rt_list_select.svg
// module id = 696
// module chunks = 99